import { useLocation } from 'react-router';
import { Link } from './ScopedLink';
import { selectedBuilding } from './building-scope';
import { calendarReturnContext } from './calendar-navigation';

export function CalendarReturnLink({fallback=false}:{fallback?:boolean}) {
  const location=useLocation(),context=calendarReturnContext(location.state,selectedBuilding(location.pathname,location.search));
  if(!context&&!fallback)return null;
  return <Link className="back-link" to={context?.to??'/calendar'}
    state={context?{calendarSearch:context.search,calendarFocusKey:context.focusKey}:undefined}>Return to Calendar</Link>;
}
